import { render, staticRenderFns } from "./SignaturePadComponent.vue?vue&type=template&id=44735c3a&"
import script from "./SignaturePadComponent.vue?vue&type=script&lang=js&"
export * from "./SignaturePadComponent.vue?vue&type=script&lang=js&"
import style0 from "./SignaturePadComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports